import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { getPageContents } from "../../../actions/admin/cmspage";

import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import { cn } from "../../../utils/classnames";
import { createTypographyHelper } from "../../../utils/typography";

import { TheLuxuryFleetDetail } from "./components/TheLuxuryFleetDetail";
import { JapanPrivateTourDetail } from "./components/JapanPrivateTourDetail";


const AboutBanner = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/about/banner.jpg";
const AboutPage = () => {
  const page_name = "cms-index";
  const _ = useSelector((state) => state.cmspage);

  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);
  const dispatch = useDispatch();

  const tabList = [
    {
      id: "luxuryFleet",
      label: t("AboutPage.LuxuryFleet.Title"),
    },
    {
      id: "japanPrivateTour",
      label: t("AboutPage.JapanPrivateTour.Title"),
    },
  ];
  const [activeTab, setActiveTab] = useState(tabList[0]);

  useEffect(() => {
    dispatch(getPageContents(page_name));
  }, [dispatch]);

  return (
    <FrontLayout>
      <div className="tw:relative tw:max-w-[1920px] tw:mx-auto tw:font-hanken-grotesk tw:mt-[88px] tw:mb-[64px] tw:lg:mb-[88px]">
        <div className="tw:max-w-[1920px] tw:m-auto tw:relative">
          <div className="tw:bg-[linear-gradient(87.06deg,#000000_6.43%,rgba(40,42,45,0.3)_46.3%)] tw:w-full tw:h-full tw:absolute tw:top-0 tw:left-0"></div>
          <img
            src={AboutBanner}
            alt="About Banner"
            className="tw:w-full tw:h-[430px] tw:object-cover"
          />
          <div className="tw:absolute tw:left-5 tw:bottom-8 tw:lg:left-[82px] tw:lg:bottom-[65px] tw:space-y-[14px] tw:z-50">
            <div className="tw:text-[#DBBE78] tw:text-[8px] tw:tracking-[3px] tw:font-semibold tw:font-hanken-grotesk tw:leading-none tw:uppercase">
              {t("About.Us")}
            </div>
            <div className="tw:text-[34px] tw:lg:text-[45px] tw:font-libre-caslon-display tw:leading-[58px] tw:text-white tw:font-normal">
              {t("Corporate.Profile")}
            </div>
          </div>
        </div>
        <div className="">
          <div className="tw:bg-[#F9F9F9] tw:relative tw:border-b tw:border-b-[#8D8D8D] tw:h-[72px] tw:lg:h-[100px]">
            <div className="tw:flex tw:lg:px-[82px] tw:lg:justify-start tw:px-3 tw:pt-3 tw:lg:pt-[27px] tw:overflow-x-auto tw:whitespace-nowrap tw:absolute tw:w-full">
              {tabList.map((tab) => (
                <div
                  className={cn(
                    "tw:flex-1 tw:lg:flex-0 tw:text-center tw:flex-shrink-0 tw:h-[60px] tw:lg:h-[73px] tw:px-5 tw:lg:px-[26px] tw:flex tw:items-center tw:justify-center tw:font-hanken-grotesk tw:font-normal tw:lg:font-medium tw:space-x-2 tw:lg:space-x-3",
                    getTypographyClass(13),
                    getTypographyClass(14, "lg"),
                    activeTab.id === tab.id
                      ? "tw:bg-white tw:border-x tw:border-x-[#8D8D8D] tw:border-t tw:border-t-[#8D8D8D] tw:text-[#282828] tw:rounded-tl-md tw:rounded-tr-md"
                      : "tw:text-[#8D8D8D] tw:cursor-pointer"
                  )}
                  onClick={() => setActiveTab(tab)}
                  key={tab.id}
                >
                  <div>{t(tab.label)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {activeTab.id === "luxuryFleet" && <TheLuxuryFleetDetail />}
        {activeTab.id === "japanPrivateTour" && <JapanPrivateTourDetail />}

      </div>
    </FrontLayout>
  )
}

export default AboutPage;